import { useInstance } from '@meraki-internal/react-dependency-injection';
import { BulkMissionExport } from './BulkMissionExport.ts';
import { AlertPresenter } from '../../app/AlertBinder.tsx';
import { DocumentIcon, ShareIcon } from '../../components/icons/Icons.tsx';
import { RevenueCatModel } from '../../paywall/revenue-cat/RevenueCatModel.ts';
import { useSubscription } from '@meraki-internal/state';
import { PaywallDialogViewModel } from '../../paywall/PaywallDialogViewModel.tsx';
import { Button } from '../../components/button/Button.tsx';
import { useIsNative } from '../../support/hooks/useIsNative.tsx';

export const BulkExportMissionsButton: React.FC<{disabled?: boolean}> = ({ disabled }) => {
    const alert = useInstance(AlertPresenter);

    const isNative = useIsNative();

    const exporter = useInstance(BulkMissionExport);
    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    const paywallVM = useInstance(PaywallDialogViewModel);

    const onClick = async () => {
        const hasPurchased = await paywallVM.requirePurchase({ triggerSource: 'bulk-export' });
        if (hasPurchased){
            try {
                await exporter.exportToCSV();
            }
            catch (err){
                alert.showAndLogError(err);
            }
        }
    };

    return (
        <Button
            onClick={onClick}
            expand="block"
            fill="outline"
            dataType="export-missions-csv"
            disabled={disabled}
        >
            {isNative ? <ShareIcon /> : <DocumentIcon />}
            <span style={{ marginLeft: 6 }}>Export All</span>
        </Button>
    );
};
